import classNames from 'classnames';
import { MdClose } from 'react-icons/md';
import { Button } from '~/components/ui/button';
import { useCouponPopup } from './useCouponPopup';
import styles from './CouponPopup.module.css';

function CloseCouponPopup() {
    const { close } = useCouponPopup();
    return <Button className={styles.closeButton} preset="secondary" icon={<MdClose />} onClick={close} />;
}

/**
 * Coupon popup component - full page overlay for coupon modals
 * @returns the coupon popup component
 */
export function CouponPopup() {
    const content = useCouponPopup((state) => state.content);

    return (
        <div className={classNames(styles.container, content ? styles.show : styles.hide)}>
            {content && (
                <>
                    <CloseCouponPopup />
                    <div className={styles.content}>{content}</div>
                </>
            )}
        </div>
    );
}
